import https from "./WebHttpService";
import ProfileService from 'common/ProfileService';

export default new ProfileService(https);
